import { Exception } from '@core/exceptions/exception';

export class ActivationException extends Exception {
  constructor(message: string = 'Activation process exception.') {
    super(message);
  }
}
